export default {
  masterChef: {
    250: '0x7C36c64811219CF9B797C5D9b264d9E7cdade7a4',
    4002: '0x67d7a98dbc2c773048f84071e7a77ea1841f0376',
  },
  multiCall: {
    250: '0xE8Aa025a25C8Bc26975B4e093f51b75bAa5391b4',
    4002: '0xa9788CDc2084557e6551797d28CCb4BE8001B0A6',
  },
  presale: {
    250: '0x4aad757bae148528335339f350ab08e70094e190',
    4002: '0x742c3124ab6c92d4b6b5b73ecdff21ba423d3351',
  },
  want: {
    250: '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83',
  },
  dmdvault: {
    250: '0xe1930eA19a0a17AcbBADCaAF31F49c6b8Dd2c88c',
  },
  nftkey: {
    250: '0x1A7d6ed890b6C284271AD27E7AbE8Fb5211D0739',
  },
  zap: {
    250: '0x0027ade05fb997453b8cafcaea207f2380ce78d3',
  },
  spookySwap: {
    250: '0xf491e7b69e4244ad4002bc14e878a34207e38c29',
  },
  nftLaunchpadFactory: {
    250: '0xeFd446dAEC749fd27ebb1eAc5B8407108Fd06605',
    4002: '0x92303b69C5340Dd0632Bd1C34FF12691Fa7920fA',
  },
  nftLaunchpadFactoryV2: {
    250: '0xa7bccB34F160DC560593C822bAfb3aF74be93C48',
    4002: '0xa1f6507Ef328e26f0CE68229Dc16abE352B177a9',
  },
  nftMultiTransfer: {
    250: '0xdfc5C6951863d25d5635d08ca0b53693e745087C',
    4002: '',
  },
  lottery: {
    250: '0x6862f48483D80a18572f5f40b17731981e297623',
    4002: '0xA9d00dB5352790dEf981A31B2Bf8DABCC272A357',
  },
}
